export const merchantToolsTranslations = {
  en: {
    'merchantTools.title': 'Merchant Tools',
    'merchantTools.subtitle': 'Manage your business operations and selling tools',
    'merchantTools.viewPublicProfile': 'View Public Profile',
    'merchantTools.view': 'View',
    'merchantTools.fastTrack': 'Fast-Track Setup',
    'merchantTools.setup': 'Setup',
    'merchantTools.settings': 'Merchant Settings',
    'merchantTools.completePayoutSetup': 'Complete Your Payout Setup',
    'merchantTools.payoutSetupDesc': 'To receive payments from your sales, you need to set up one of the following:',
    'merchantTools.linkBankAccount': 'Link Bank Account',
    'merchantTools.stripeConnect': 'Stripe Connect',
    'merchantTools.paypalAccount': 'PayPal Account',
    'merchantTools.completeProfile': 'Complete your merchant profile to unlock all features and start accepting payments.',
    'merchantTools.setupNow': 'Set Up Now →',
    'merchantTools.dashboard': 'Dashboard',
    'merchantTools.newTokens': 'New Tokens!',
    'merchantTools.quickActions': 'Quick Actions (OOP Model Demo)',
    'merchantTools.actionsAvailable': '{count} available',
    'merchantTools.actionTriggered': 'Action Triggered',
    'merchantTools.wouldOpen': 'Would open: {action}',
    'merchantTools.permissions': 'Your Merchant Permissions',
    'merchantTools.permissions.createProducts': 'Create Products',
    'merchantTools.permissions.apiKeys': 'API Keys',
    'merchantTools.permissions.analytics': 'Analytics',
    'merchantTools.permissions.invoicing': 'Invoicing',
    'merchantTools.permissions.qrCodes': 'QR Codes',
    'merchantTools.permissions.exportData': 'Export Data',
    'merchantTools.announce': 'Announce to Followers',
    'merchantTools.followers': '{count} followers',
    'merchantTools.createAnnouncement': 'Create Announcement',
    'merchantTools.announcementTitle': 'Title',
    'merchantTools.announcementTitlePlaceholder': 'Enter announcement title...',
    'merchantTools.announcementMessage': 'Message',
    'merchantTools.announcementMessagePlaceholder': 'Write your announcement message...',
    'merchantTools.sendToAll': 'Send to all followers',
    'merchantTools.selectFollowers': 'Select Followers',
    'merchantTools.sending': 'Sending...',
    'merchantTools.sendAnnouncement': 'Send Announcement',
    'merchantTools.noFollowers': "You don't have any followers yet. Followers are users whose cash tokens you have redeemed.",
    'merchantTools.yourFollowers': 'Your Followers',
    'merchantTools.active': 'Active',
    'merchantTools.tokensRedeemed': '{count} tokens redeemed',
    'merchantTools.followingSince': 'Following since {date}',
    'merchantTools.noFollowersYet': 'No followers yet',
    'merchantTools.noFollowersHint': 'Users become followers when you redeem their cash tokens',
    'merchantTools.previousAnnouncements': 'Previous Announcements',
    'merchantTools.recipients': '{count} recipients',
    'merchantTools.read': '{count} read',
    'merchantTools.sellingTools': 'Selling Tools',
    'merchantTools.productCatalog': 'Product Catalog',
    'merchantTools.manageProducts': 'Manage your products and inventory',
    'merchantTools.uploadMenu': 'Upload Menu (AI)',
    'merchantTools.importFeed': 'Import Feed',
    'merchantTools.addProduct': 'Add Product',
    'merchantTools.integrations': 'E-commerce Platform Integrations',
    'merchantTools.integrationsDesc': 'Connect Vaiu payments to your online store with our plugins and extensions',
    'merchantTools.wooCommerce': 'WooCommerce',
    'merchantTools.wooCommerceDesc': 'Accept Vaiu payments directly in your WooCommerce store',
    'merchantTools.wooCommercePlugin': 'WordPress Plugin',
    'merchantTools.download': 'Download',
    'merchantTools.docs': 'Docs',
    'merchantTools.shopify': 'Shopify',
    'merchantTools.shopifyDesc': 'Install the Vaiu payment app from Shopify App Store',
    'merchantTools.shopifyApp': 'Shopify App',
    'merchantTools.install': 'Install',
    'merchantTools.guide': 'Guide',
    'merchantTools.magento': 'Magento',
    'merchantTools.magentoDesc': 'Integrate Vaiu payments with your Magento store',
    'merchantTools.magentoExtension': 'Extension',
    'merchantTools.businessFiles': 'Business Files',
    'merchantTools.businessFilesDesc': 'Upload and manage your business documents, logos, and media',
    'merchantTools.uploading': 'Uploading...',
    'merchantTools.uploadFiles': 'Upload Files',
    'merchantTools.noFiles': 'No files uploaded yet',
    'merchantTools.noFilesDesc': 'Upload business documents, logos, and media files',
    'merchantTools.unlockPotential': 'Ready to unlock your full merchant potential?',
    'merchantTools.unlockPotentialDesc': 'Complete your profile setup to access all features, accept payments, and grow your business.',
    'merchantTools.completeSetup': 'Complete Setup',
    'merchantTools.toast.menuUploaded': 'Menu Uploaded Successfully',
    'merchantTools.toast.menuUploadedDesc': 'Added {count} items to your product catalog.',
    'merchantTools.toast.profileError': 'Failed to load merchant profile',
    'merchantTools.toast.filesError': 'Failed to load files',
    'merchantTools.toast.productsError': 'Failed to load products',
    'merchantTools.toast.followersError': 'Failed to load followers',
    'merchantTools.toast.announcementError': 'Please fill in both title and message',
    'merchantTools.toast.announcementFollowersError': 'Please select at least one follower or send to all',
    'merchantTools.toast.announcementSuccess': 'Announcement sent to {count} followers',
    'merchantTools.toast.announcementFailed': 'Failed to send announcement',
    'merchantTools.toast.followerRemoved': 'Follower removed successfully',
    'merchantTools.toast.followerRemoveError': 'Failed to remove follower',
    'merchantTools.toast.filesUploaded': 'Files uploaded successfully',
    'merchantTools.toast.filesUploadError': 'Failed to upload files',
    'merchantTools.toast.fileDeleted': 'File deleted successfully',
    'merchantTools.toast.fileDeleteError': 'Failed to delete file',
    'merchantTools.toast.productCreated': 'Product created successfully',
    'merchantTools.toast.productCreateError': 'Failed to create product',
    'merchantTools.toast.productUpdated': 'Product updated successfully',
    'merchantTools.toast.productUpdateError': 'Failed to update product',
    'merchantTools.toast.productDeleted': 'Product deleted successfully',
    'merchantTools.toast.productDeleteError': 'Failed to delete product',
    'vaiu.merchant.getting_paid': 'Getting Paid',
    'vaiu.merchant.getting_paid_description': 'Create payment links and QR codes to receive payments from customers',
    'vaiu.merchant.payment_link': 'Payment Link',
    'vaiu.merchant.embedded_payment': 'Embedded Payment',
    'vaiu.merchant.preview': 'Preview',
    'vaiu.merchant.download_qr': 'Download QR',
    'vaiu.merchant.copy_link': 'Copy Link',
    'vaiu.merchant.copy_iframe': 'Copy Iframe',
  },
  es: {
    'merchantTools.title': 'Herramientas de Comerciante',
    'merchantTools.subtitle': 'Gestiona las operaciones de tu negocio y las herramientas de venta',
    'merchantTools.viewPublicProfile': 'Ver Perfil Público',
    'merchantTools.view': 'Ver',
    'merchantTools.fastTrack': 'Configuración Rápida',
    'merchantTools.setup': 'Configurar',
    'merchantTools.settings': 'Configuración de Comerciante',
    'merchantTools.completePayoutSetup': 'Completa la Configuración de tus Pagos',
    'merchantTools.payoutSetupDesc': 'Para recibir pagos de tus ventas, necesitas configurar uno de los siguientes:',
    'merchantTools.linkBankAccount': 'Vincular Cuenta Bancaria',
    'merchantTools.stripeConnect': 'Stripe Connect',
    'merchantTools.paypalAccount': 'Cuenta de PayPal',
    'merchantTools.completeProfile': 'Completa tu perfil de comerciante para desbloquear todas las funciones y empezar a aceptar pagos.',
    'merchantTools.setupNow': 'Configurar Ahora →',
    'merchantTools.dashboard': 'Panel de Control',
    'merchantTools.newTokens': '¡Nuevos Tokens!',
    'merchantTools.quickActions': 'Acciones Rápidas (Demo del Modelo OOP)',
    'merchantTools.actionsAvailable': '{count} disponibles',
    'merchantTools.actionTriggered': 'Acción Disparada',
    'merchantTools.wouldOpen': 'Abriría: {action}',
    'merchantTools.permissions': 'Tus Permisos de Comerciante',
    'merchantTools.permissions.createProducts': 'Crear Productos',
    'merchantTools.permissions.apiKeys': 'Claves de API',
    'merchantTools.permissions.analytics': 'Analíticas',
    'merchantTools.permissions.invoicing': 'Facturación',
    'merchantTools.permissions.qrCodes': 'Códigos QR',
    'merchantTools.permissions.exportData': 'Exportar Datos',
    'merchantTools.announce': 'Anunciar a los Seguidores',
    'merchantTools.followers': '{count} seguidores',
    'merchantTools.createAnnouncement': 'Crear Anuncio',
    'merchantTools.announcementTitle': 'Título',
    'merchantTools.announcementTitlePlaceholder': 'Introduce el título del anuncio...',
    'merchantTools.announcementMessage': 'Mensaje',
    'merchantTools.announcementMessagePlaceholder': 'Escribe el mensaje de tu anuncio...',
    'merchantTools.sendToAll': 'Enviar a todos los seguidores',
    'merchantTools.selectFollowers': 'Seleccionar Seguidores',
    'merchantTools.sending': 'Enviando...',
    'merchantTools.sendAnnouncement': 'Enviar Anuncio',
    'merchantTools.noFollowers': 'Aún no tienes seguidores. Los usuarios se convierten en seguidores cuando canjeas sus tokens de efectivo.',
    'merchantTools.yourFollowers': 'Tus Seguidores',
    'merchantTools.active': 'Activo',
    'merchantTools.tokensRedeemed': '{count} tokens canjeados',
    'merchantTools.followingSince': 'Siguiendo desde {date}',
    'merchantTools.noFollowersYet': 'Aún no hay seguidores',
    'merchantTools.noFollowersHint': 'Los usuarios se convierten en seguidores cuando canjeas sus tokens de efectivo',
    'merchantTools.previousAnnouncements': 'Anuncios Anteriores',
    'merchantTools.recipients': '{count} destinatarios',
    'merchantTools.read': '{count} leídos',
    'merchantTools.sellingTools': 'Herramientas de Venta',
    'merchantTools.productCatalog': 'Catálogo de Productos',
    'merchantTools.manageProducts': 'Gestiona tus productos e inventario',
    'merchantTools.uploadMenu': 'Subir Menú (IA)',
    'merchantTools.importFeed': 'Importar Feed',
    'merchantTools.addProduct': 'Añadir Producto',
    'merchantTools.integrations': 'Integraciones con Plataformas de E-commerce',
    'merchantTools.integrationsDesc': 'Conecta los pagos de Vaiu a tu tienda online con nuestros plugins y extensiones',
    'merchantTools.wooCommerce': 'WooCommerce',
    'merchantTools.wooCommerceDesc': 'Acepta pagos de Vaiu directamente en tu tienda de WooCommerce',
    'merchantTools.wooCommercePlugin': 'Plugin de WordPress',
    'merchantTools.download': 'Descargar',
    'merchantTools.docs': 'Docs',
    'merchantTools.shopify': 'Shopify',
    'merchantTools.shopifyDesc': 'Instala la aplicación de pagos de Vaiu desde la App Store de Shopify',
    'merchantTools.shopifyApp': 'App de Shopify',
    'merchantTools.install': 'Instalar',
    'merchantTools.guide': 'Guía',
    'merchantTools.magento': 'Magento',
    'merchantTools.magentoDesc': 'Integra los pagos de Vaiu con tu tienda de Magento',
    'merchantTools.magentoExtension': 'Extensión',
    'merchantTools.businessFiles': 'Archivos del Negocio',
    'merchantTools.businessFilesDesc': 'Sube y gestiona los documentos, logos y medios de tu negocio',
    'merchantTools.uploading': 'Subiendo...',
    'merchantTools.uploadFiles': 'Subir Archivos',
    'merchantTools.noFiles': 'Aún no has subido archivos',
    'merchantTools.noFilesDesc': 'Sube documentos del negocio, logos y archivos multimedia',
    'merchantTools.unlockPotential': '¿Listo para desbloquear todo tu potencial de comerciante?',
    'merchantTools.unlockPotentialDesc': 'Completa la configuración de tu perfil para acceder a todas las funciones, aceptar pagos y hacer crecer tu negocio.',
    'merchantTools.completeSetup': 'Completar Configuración',
    'merchantTools.toast.menuUploaded': 'Menú Subido con Éxito',
    'merchantTools.toast.menuUploadedDesc': 'Se han añadido {count} artículos a tu catálogo de productos.',
    'merchantTools.toast.profileError': 'No se pudo cargar el perfil del comerciante',
    'merchantTools.toast.filesError': 'No se pudieron cargar los archivos',
    'merchantTools.toast.productsError': 'No se pudieron cargar los productos',
    'merchantTools.toast.followersError': 'No se pudieron cargar los seguidores',
    'merchantTools.toast.announcementError': 'Por favor, rellena el título y el mensaje',
    'merchantTools.toast.announcementFollowersError': 'Por favor, selecciona al menos un seguidor o envía a todos',
    'merchantTools.toast.announcementSuccess': 'Anuncio enviado a {count} seguidores',
    'merchantTools.toast.announcementFailed': 'No se pudo enviar el anuncio',
    'merchantTools.toast.followerRemoved': 'Seguidor eliminado con éxito',
    'merchantTools.toast.followerRemoveError': 'No se pudo eliminar el seguidor',
    'merchantTools.toast.filesUploaded': 'Archivos subidos con éxito',
    'merchantTools.toast.filesUploadError': 'No se pudieron subir los archivos',
    'merchantTools.toast.fileDeleted': 'Archivo eliminado con éxito',
    'merchantTools.toast.fileDeleteError': 'No se pudo eliminar el archivo',
    'merchantTools.toast.productCreated': 'Producto creado con éxito',
    'merchantTools.toast.productCreateError': 'No se pudo crear el producto',
    'merchantTools.toast.productUpdated': 'Producto actualizado con éxito',
    'merchantTools.toast.productUpdateError': 'No se pudo actualizar el producto',
    'merchantTools.toast.productDeleted': 'Producto eliminado con éxito',
    'merchantTools.toast.productDeleteError': 'No se pudo eliminar el producto',
    'vaiu.merchant.getting_paid': 'Recibir Pagos',
    'vaiu.merchant.getting_paid_description': 'Crea enlaces de pago y códigos QR para recibir pagos de los clientes',
    'vaiu.merchant.payment_link': 'Enlace de Pago',
    'vaiu.merchant.embedded_payment': 'Pago Integrado',
    'vaiu.merchant.preview': 'Vista Previa',
    'vaiu.merchant.download_qr': 'Descargar QR',
    'vaiu.merchant.copy_link': 'Copiar Enlace',
    'vaiu.merchant.copy_iframe': 'Copiar Iframe',
  },
  fr: {
    'merchantTools.title': 'Outils marchand',
    'merchantTools.subtitle': 'Gérez les opérations de votre entreprise et les outils de vente',
    'merchantTools.viewPublicProfile': 'Voir le profil public',
    'merchantTools.view': 'Voir',
    'merchantTools.fastTrack': 'Configuration rapide',
    'merchantTools.setup': 'Configuration',
    'merchantTools.settings': 'Paramètres marchand',
    'merchantTools.completePayoutSetup': 'Complétez votre configuration de paiement',
    'merchantTools.payoutSetupDesc': 'Pour recevoir des paiements de vos ventes, vous devez configurer l\'un des éléments suivants :',
    'merchantTools.linkBankAccount': 'Lier le compte bancaire',
    'merchantTools.stripeConnect': 'Stripe Connect',
    'merchantTools.paypalAccount': 'Compte PayPal',
    'merchantTools.completeProfile': 'Complétez votre profil marchand pour débloquer toutes les fonctionnalités et commencer à accepter les paiements.',
    'merchantTools.setupNow': 'Configurer maintenant →',
    'merchantTools.dashboard': 'Tableau de bord',
    'merchantTools.newTokens': 'Nouveaux tokens !',
    'merchantTools.quickActions': 'Actions rapides (Démo du modèle OOP)',
    'merchantTools.actionsAvailable': '{count} disponibles',
    'merchantTools.actionTriggered': 'Action déclenchée',
    'merchantTools.wouldOpen': 'Ouvrirait : {action}',
    'merchantTools.permissions': 'Vos permissions marchand',
    'merchantTools.permissions.createProducts': 'Créer des produits',
    'merchantTools.permissions.apiKeys': 'Clés API',
    'merchantTools.permissions.analytics': 'Analytiques',
    'merchantTools.permissions.invoicing': 'Facturation',
    'merchantTools.permissions.qrCodes': 'Codes QR',
    'merchantTools.permissions.exportData': 'Exporter les données',
    'merchantTools.announce': 'Annoncer aux abonnés',
    'merchantTools.followers': '{count} abonnés',
    'merchantTools.createAnnouncement': 'Créer une annonce',
    'merchantTools.announcementTitle': 'Titre',
    'merchantTools.announcementTitlePlaceholder': 'Entrez le titre de l\'annonce...',
    'merchantTools.announcementMessage': 'Message',
    'merchantTools.announcementMessagePlaceholder': 'Écrivez votre message d\'annonce...',
    'merchantTools.sendToAll': 'Envoyer à tous les abonnés',
    'merchantTools.selectFollowers': 'Sélectionner les abonnés',
    'merchantTools.sending': 'Envoi...',
    'merchantTools.sendAnnouncement': 'Envoyer l\'annonce',
    'merchantTools.noFollowers': 'Vous n\'avez pas encore d\'abonnés. Les abonnés sont des utilisateurs dont vous avez utilisé les tokens de paiement.',
    'merchantTools.yourFollowers': 'Vos abonnés',
    'merchantTools.active': 'Actif',
    'merchantTools.tokensRedeemed': '{count} tokens utilisés',
    'merchantTools.followingSince': 'Abonné depuis {date}',
    'merchantTools.noFollowersYet': 'Pas encore d\'abonnés',
    'merchantTools.noFollowersHint': 'Les utilisateurs deviennent abonnés lorsque vous utilisez leurs tokens de paiement',
    'merchantTools.previousAnnouncements': 'Annonces précédentes',
    'merchantTools.recipients': '{count} destinataires',
    'merchantTools.read': '{count} lus',
    'merchantTools.sellingTools': 'Outils de vente',
    'merchantTools.productCatalog': 'Catalogue de produits',
    'merchantTools.manageProducts': 'Gérez vos produits et votre inventaire',
    'merchantTools.uploadMenu': 'Télécharger le menu (IA)',
    'merchantTools.importFeed': 'Importer le flux',
    'merchantTools.addProduct': 'Ajouter un produit',
    'merchantTools.integrations': 'Intégrations de plateformes e-commerce',
    'merchantTools.integrationsDesc': 'Connectez les paiements Vaiu à votre boutique en ligne avec nos plugins et extensions',
    'merchantTools.wooCommerce': 'WooCommerce',
    'merchantTools.wooCommerceDesc': 'Acceptez les paiements Vaiu directement dans votre boutique WooCommerce',
    'merchantTools.wooCommercePlugin': 'Plugin WordPress',
    'merchantTools.download': 'Télécharger',
    'merchantTools.docs': 'Documentation',
    'merchantTools.shopify': 'Shopify',
    'merchantTools.shopifyDesc': 'Installez l\'application de paiement Vaiu depuis le Shopify App Store',
    'merchantTools.shopifyApp': 'Application Shopify',
    'merchantTools.install': 'Installer',
    'merchantTools.guide': 'Guide',
    'merchantTools.magento': 'Magento',
    'merchantTools.magentoDesc': 'Intégrez les paiements Vaiu avec votre boutique Magento',
    'merchantTools.magentoExtension': 'Extension',
    'merchantTools.businessFiles': 'Fichiers commerciaux',
    'merchantTools.businessFilesDesc': 'Téléchargez et gérez vos documents commerciaux, logos et médias',
    'merchantTools.uploading': 'Téléchargement...',
    'merchantTools.uploadFiles': 'Télécharger des fichiers',
    'merchantTools.noFiles': 'Aucun fichier téléchargé pour le moment',
    'merchantTools.noFilesDesc': 'Téléchargez des documents commerciaux, logos et fichiers multimédias',
    'merchantTools.unlockPotential': 'Prêt à débloquer tout votre potentiel marchand ?',
    'merchantTools.unlockPotentialDesc': 'Complétez la configuration de votre profil pour accéder à toutes les fonctionnalités, accepter les paiements et développer votre entreprise.',
    'merchantTools.completeSetup': 'Terminer la configuration',
    'merchantTools.toast.menuUploaded': 'Menu téléchargé avec succès',
    'merchantTools.toast.menuUploadedDesc': '{count} articles ajoutés à votre catalogue de produits.',
    'merchantTools.toast.profileError': 'Échec du chargement du profil du marchand',
    'merchantTools.toast.filesError': 'Échec du chargement des fichiers',
    'merchantTools.toast.productsError': 'Échec du chargement des produits',
    'merchantTools.toast.followersError': 'Échec du chargement des abonnés',
    'merchantTools.toast.announcementError': 'Veuillez remplir à la fois le titre et le message',
    'merchantTools.toast.announcementFollowersError': 'Veuillez sélectionner au moins un abonné ou envoyer à tous',
    'merchantTools.toast.announcementSuccess': 'Annonce envoyée à {count} abonnés',
    'merchantTools.toast.announcementFailed': 'Échec de l\'envoi de l\'annonce',
    'merchantTools.toast.followerRemoved': 'Abonné supprimé avec succès',
    'merchantTools.toast.followerRemoveError': 'Échec de la suppression de l\'abonné',
    'merchantTools.toast.filesUploaded': 'Fichiers téléchargés avec succès',
    'merchantTools.toast.filesUploadError': 'Échec du téléchargement des fichiers',
    'merchantTools.toast.fileDeleted': 'Fichier supprimé avec succès',
    'merchantTools.toast.fileDeleteError': 'Échec de la suppression du fichier',
    'merchantTools.toast.productCreated': 'Produit créé avec succès',
    'merchantTools.toast.productCreateError': 'Échec de la création du produit',
    'merchantTools.toast.productUpdated': 'Produit mis à jour avec succès',
    'merchantTools.toast.productUpdateError': 'Échec de la mise à jour du produit',
    'merchantTools.toast.productDeleted': 'Produit supprimé avec succès',
    'merchantTools.toast.productDeleteError': 'Échec de la suppression du produit',
    'vaiu.merchant.getting_paid': 'Recevoir des Paiements',
    'vaiu.merchant.getting_paid_description': 'Créez des liens de paiement et des codes QR pour recevoir des paiements des clients',
    'vaiu.merchant.payment_link': 'Lien de Paiement',
    'vaiu.merchant.embedded_payment': 'Paiement Intégré',
    'vaiu.merchant.preview': 'Aperçu',
    'vaiu.merchant.download_qr': 'Télécharger QR',
    'vaiu.merchant.copy_link': 'Copier le Lien',
    'vaiu.merchant.copy_iframe': 'Copier Iframe',
  },
  sq: {
    'merchantTools.title': 'Mjetet e Tregtarit',
    'merchantTools.subtitle': 'Menaxhoni operacionet e biznesit dhe mjetet e shitjes',
    'merchantTools.viewPublicProfile': 'Shiko Profilin Publik',
    'merchantTools.view': 'Shiko',
    'merchantTools.fastTrack': 'Konfigurim i Shpejtë',
    'merchantTools.setup': 'Konfiguro',
    'merchantTools.settings': 'Cilësimet e Tregtarit',
    'merchantTools.completePayoutSetup': 'Plotësoni Konfigurimin e Pagesës',
    'merchantTools.payoutSetupDesc': 'Për të marrë pagesa nga shitjet tuaja, duhet të konfiguroni një nga sa vijon:',
    'merchantTools.linkBankAccount': 'Lidh Llogarinë Bankare',
    'merchantTools.stripeConnect': 'Stripe Connect',
    'merchantTools.paypalAccount': 'Llogari PayPal',
    'merchantTools.completeProfile': 'Plotësoni profilin tuaj të tregtarit për të zhbllokuar të gjitha veçoritë dhe për të filluar të pranoni pagesa.',
    'merchantTools.setupNow': 'Konfiguro Tani →',
    'merchantTools.dashboard': 'Paneli',
    'merchantTools.newTokens': 'Tokena të Reja!',
    'merchantTools.quickActions': 'Veprime të Shpejta (Demo Modeli OOP)',
    'merchantTools.actionsAvailable': '{count} në dispozicion',
    'merchantTools.actionTriggered': 'Veprim i Aktivizuar',
    'merchantTools.wouldOpen': 'Do të hapte: {action}',
    'merchantTools.permissions': 'Lejet tuaja të Tregtarit',
    'merchantTools.permissions.createProducts': 'Krijo Produkte',
    'merchantTools.permissions.apiKeys': 'Çelësat API',
    'merchantTools.permissions.analytics': 'Analitika',
    'merchantTools.permissions.invoicing': 'Faturimi',
    'merchantTools.permissions.qrCodes': 'Kodet QR',
    'merchantTools.permissions.exportData': 'Eksporto Të Dhëna',
    'merchantTools.announce': 'Shpall te Ndjekësit',
    'merchantTools.followers': '{count} ndjekës',
    'merchantTools.createAnnouncement': 'Krijo Shpallje',
    'merchantTools.announcementTitle': 'Titulli',
    'merchantTools.announcementTitlePlaceholder': 'Shkruani titullin e shpalljes...',
    'merchantTools.announcementMessage': 'Mesazhi',
    'merchantTools.announcementMessagePlaceholder': 'Shkruani mesazhin tuaj të shpalljes...',
    'merchantTools.sendToAll': 'Dërgo te të gjithë ndjekësit',
    'merchantTools.selectFollowers': 'Zgjidh Ndjekësit',
    'merchantTools.sending': 'Duke dërguar...',
    'merchantTools.sendAnnouncement': 'Dërgo Shpalljen',
    'merchantTools.noFollowers': 'Ende nuk keni ndjekës. Ndjekësit janë përdorues të cilëve u keni shlyer tokenat e tyre të parave.',
    'merchantTools.yourFollowers': 'Ndjekësit tuaj',
    'merchantTools.active': 'Aktiv',
    'merchantTools.tokensRedeemed': '{count} tokena të shlyera',
    'merchantTools.followingSince': 'Duke ndjekur që nga {date}',
    'merchantTools.noFollowersYet': 'Ende nuk ka ndjekës',
    'merchantTools.noFollowersHint': 'Përdoruesit bëhen ndjekës kur ju shlyeni tokenat e tyre të parave',
    'merchantTools.previousAnnouncements': 'Shpalljet e Mëparshme',
    'merchantTools.recipients': '{count} marrës',
    'merchantTools.read': '{count} të lexuara',
    'merchantTools.sellingTools': 'Mjetet e Shitjes',
    'merchantTools.productCatalog': 'Katalogu i Produkteve',
    'merchantTools.manageProducts': 'Menaxhoni produktet dhe inventarin tuaj',
    'merchantTools.uploadMenu': 'Ngarko Menunë (AI)',
    'merchantTools.importFeed': 'Importo Feed',
    'merchantTools.addProduct': 'Shto Produkt',
    'merchantTools.integrations': 'Integrimet e Platformave E-commerce',
    'merchantTools.integrationsDesc': 'Lidhni pagesat Vaiu me dyqanin tuaj online me plugin-et dhe zgjerimet tona',
    'merchantTools.wooCommerce': 'WooCommerce',
    'merchantTools.wooCommerceDesc': 'Pranoni pagesat Vaiu direkt në dyqanin tuaj WooCommerce',
    'merchantTools.wooCommercePlugin': 'Plugin WordPress',
    'merchantTools.download': 'Shkarko',
    'merchantTools.docs': 'Dokumentacioni',
    'merchantTools.shopify': 'Shopify',
    'merchantTools.shopifyDesc': 'Instaloni aplikacionin e pagesës Vaiu nga Shopify App Store',
    'merchantTools.shopifyApp': 'Aplikacion Shopify',
    'merchantTools.install': 'Instalo',
    'merchantTools.guide': 'Udhëzues',
    'merchantTools.magento': 'Magento',
    'merchantTools.magentoDesc': 'Integroni pagesat Vaiu me dyqanin tuaj Magento',
    'merchantTools.magentoExtension': 'Zgjerim',
    'merchantTools.businessFiles': 'Skedarët e Biznesit',
    'merchantTools.businessFilesDesc': 'Ngarkoni dhe menaxhoni dokumentet, logot dhe mediat e biznesit tuaj',
    'merchantTools.uploading': 'Duke ngarkuar...',
    'merchantTools.uploadFiles': 'Ngarko Skedarë',
    'merchantTools.noFiles': 'Ende nuk ka skedarë të ngarkuar',
    'merchantTools.noFilesDesc': 'Ngarkoni dokumente biznesi, logo dhe skedarë media',
    'merchantTools.unlockPotential': 'Gati për të zhbllokuar potencialin tuaj të plotë të tregtarit?',
    'merchantTools.unlockPotentialDesc': 'Plotësoni konfigurimin e profilit tuaj për të aksesuar të gjitha veçoritë, pranuar pagesa dhe rritur biznesin tuaj.',
    'merchantTools.completeSetup': 'Plotëso Konfigurimin',
    'merchantTools.toast.menuUploaded': 'Menuja u Ngarkua me Sukses',
    'merchantTools.toast.menuUploadedDesc': 'U shtuan {count} artikuj në katalogun tuaj të produkteve.',
    'merchantTools.toast.profileError': 'Dështoi ngarkimi i profilit të tregtarit',
    'merchantTools.toast.filesError': 'Dështoi ngarkimi i skedarëve',
    'merchantTools.toast.productsError': 'Dështoi ngarkimi i produkteve',
    'merchantTools.toast.followersError': 'Dështoi ngarkimi i ndjekësve',
    'merchantTools.toast.announcementError': 'Ju lutemi plotësoni si titullin ashtu edhe mesazhin',
    'merchantTools.toast.announcementFollowersError': 'Ju lutemi zgjidhni të paktën një ndjekës ose dërgoni te të gjithë',
    'merchantTools.toast.announcementSuccess': 'Shpallja u dërgua te {count} ndjekës',
    'merchantTools.toast.announcementFailed': 'Dështoi dërgimi i shpalljes',
    'merchantTools.toast.followerRemoved': 'Ndjekësi u hoq me sukses',
    'merchantTools.toast.followerRemoveError': 'Dështoi heqja e ndjekësit',
    'merchantTools.toast.filesUploaded': 'Skedarët u ngarkuan me sukses',
    'merchantTools.toast.filesUploadError': 'Dështoi ngarkimi i skedarëve',
    'merchantTools.toast.fileDeleted': 'Skedari u fshi me sukses',
    'merchantTools.toast.fileDeleteError': 'Dështoi fshirja e skedarit',
    'merchantTools.toast.productCreated': 'Produkti u krijua me sukses',
    'merchantTools.toast.productCreateError': 'Dështoi krijimi i produktit',
    'merchantTools.toast.productUpdated': 'Produkti u përditësua me sukses',
    'merchantTools.toast.productUpdateError': 'Dështoi përditësimi i produktit',
    'merchantTools.toast.productDeleted': 'Produkti u fshi me sukses',
    'merchantTools.toast.productDeleteError': 'Dështoi fshirja e produktit',
    'vaiu.merchant.getting_paid': 'Marrja e Pagesave',
    'vaiu.merchant.getting_paid_description': 'Krijoni lidhje pagese dhe kode QR për të marrë pagesa nga klientët',
    'vaiu.merchant.payment_link': 'Lidhja e Pagesës',
    'vaiu.merchant.embedded_payment': 'Pagesa e Integruar',
    'vaiu.merchant.preview': 'Parapamje',
    'vaiu.merchant.download_qr': 'Shkarko QR',
    'vaiu.merchant.copy_link': 'Kopjo Lidhjen',
    'vaiu.merchant.copy_iframe': 'Kopjo Iframe',
  },
  ru: {
    'merchantTools.title': 'Инструменты продавца',
    'merchantTools.subtitle': 'Управляйте бизнес-операциями и инструментами продажи',
    'merchantTools.viewPublicProfile': 'Просмотр публичного профиля',
    'merchantTools.view': 'Просмотр',
    'merchantTools.fastTrack': 'Быстрая настройка',
    'merchantTools.setup': 'Настройка',
    'merchantTools.settings': 'Настройки продавца',
    'merchantTools.completePayoutSetup': 'Завершите настройку выплат',
    'merchantTools.payoutSetupDesc': 'Для получения платежей от ваших продаж вам нужно настроить одно из следующего:',
    'merchantTools.linkBankAccount': 'Привязать банковский счет',
    'merchantTools.stripeConnect': 'Stripe Connect',
    'merchantTools.paypalAccount': 'Аккаунт PayPal',
    'merchantTools.completeProfile': 'Завершите ваш профиль продавца, чтобы разблокировать все функции и начать принимать платежи.',
    'merchantTools.setupNow': 'Настроить сейчас →',
    'merchantTools.dashboard': 'Панель управления',
    'merchantTools.newTokens': 'Новые токены!',
    'merchantTools.quickActions': 'Быстрые действия (Демо OOP модели)',
    'merchantTools.actionsAvailable': '{count} доступно',
    'merchantTools.actionTriggered': 'Действие активировано',
    'merchantTools.wouldOpen': 'Откроется: {action}',
    'merchantTools.permissions': 'Ваши разрешения продавца',
    'merchantTools.permissions.createProducts': 'Создавать продукты',
    'merchantTools.permissions.apiKeys': 'API ключи',
    'merchantTools.permissions.analytics': 'Аналитика',
    'merchantTools.permissions.invoicing': 'Выставление счетов',
    'merchantTools.permissions.qrCodes': 'QR коды',
    'merchantTools.permissions.exportData': 'Экспорт данных',
    'merchantTools.announce': 'Объявить подписчикам',
    'merchantTools.followers': '{count} подписчиков',
    'merchantTools.createAnnouncement': 'Создать объявление',
    'merchantTools.announcementTitle': 'Заголовок',
    'merchantTools.announcementTitlePlaceholder': 'Введите заголовок объявления...',
    'merchantTools.announcementMessage': 'Сообщение',
    'merchantTools.announcementMessagePlaceholder': 'Напишите ваше сообщение объявления...',
    'merchantTools.sendToAll': 'Отправить всем подписчикам',
    'merchantTools.selectFollowers': 'Выбрать подписчиков',
    'merchantTools.sending': 'Отправка...',
    'merchantTools.sendAnnouncement': 'Отправить объявление',
    'merchantTools.noFollowers': 'У вас пока нет подписчиков. Подписчики - это пользователи, чьи денежные токены вы погасили.',
    'merchantTools.yourFollowers': 'Ваши подписчики',
    'merchantTools.active': 'Активен',
    'merchantTools.tokensRedeemed': '{count} токенов погашено',
    'merchantTools.followingSince': 'Подписан с {date}',
    'merchantTools.noFollowersYet': 'Пока нет подписчиков',
    'merchantTools.noFollowersHint': 'Пользователи становятся подписчиками, когда вы погашаете их денежные токены',
    'merchantTools.previousAnnouncements': 'Предыдущие объявления',
    'merchantTools.recipients': '{count} получателей',
    'merchantTools.read': '{count} прочитано',
    'merchantTools.sellingTools': 'Инструменты продажи',
    'merchantTools.productCatalog': 'Каталог продуктов',
    'merchantTools.manageProducts': 'Управляйте вашими продуктами и инвентарем',
    'merchantTools.uploadMenu': 'Загрузить меню (AI)',
    'merchantTools.importFeed': 'Импортировать ленту',
    'merchantTools.addProduct': 'Добавить продукт',
    'merchantTools.integrations': 'Интеграции платформ электронной коммерции',
    'merchantTools.integrationsDesc': 'Подключите платежи Vaiu к вашему интернет-магазину с помощью наших плагинов и расширений',
    'merchantTools.wooCommerce': 'WooCommerce',
    'merchantTools.wooCommerceDesc': 'Принимайте платежи Vaiu напрямую в вашем магазине WooCommerce',
    'merchantTools.wooCommercePlugin': 'Плагин WordPress',
    'merchantTools.download': 'Скачать',
    'merchantTools.docs': 'Документация',
    'merchantTools.shopify': 'Shopify',
    'merchantTools.shopifyDesc': 'Установите приложение Vaiu из магазина приложений Shopify',
    'merchantTools.shopifyApp': 'Приложение Shopify',
    'merchantTools.install': 'Установить',
    'merchantTools.guide': 'Руководство',
    'merchantTools.magento': 'Magento',
    'merchantTools.magentoDesc': 'Интегрируйте платежи Vaiu с вашим магазином Magento',
    'merchantTools.magentoExtension': 'Расширение',
    'merchantTools.businessFiles': 'Бизнес-файлы',
    'merchantTools.businessFilesDesc': 'Загружайте и управляйте вашими бизнес-документами, логотипами и медиа',
    'merchantTools.uploading': 'Загрузка...',
    'merchantTools.uploadFiles': 'Загрузить файлы',
    'merchantTools.noFiles': 'Файлы еще не загружены',
    'merchantTools.noFilesDesc': 'Загрузите бизнес-документы, логотипы и медиа-файлы',
    'merchantTools.unlockPotential': 'Готовы раскрыть весь потенциал продавца?',
    'merchantTools.unlockPotentialDesc': 'Завершите настройку профиля, чтобы получить доступ ко всем функциям, принимать платежи и развивать бизнес.',
    'merchantTools.completeSetup': 'Завершить настройку',
    'merchantTools.toast.menuUploaded': 'Меню успешно загружено',
    'merchantTools.toast.menuUploadedDesc': 'Добавлено {count} элементов в ваш каталог продуктов.',
    'merchantTools.toast.profileError': 'Не удалось загрузить профиль продавца',
    'merchantTools.toast.filesError': 'Не удалось загрузить файлы',
    'merchantTools.toast.productsError': 'Не удалось загрузить продукты',
    'merchantTools.toast.followersError': 'Не удалось загрузить подписчиков',
    'merchantTools.toast.announcementError': 'Пожалуйста, заполните заголовок и сообщение',
    'merchantTools.toast.announcementFollowersError': 'Пожалуйста, выберите хотя бы одного подписчика или отправьте всем',
    'merchantTools.toast.announcementSuccess': 'Объявление отправлено {count} подписчикам',
    'merchantTools.toast.announcementFailed': 'Не удалось отправить объявление',
    'merchantTools.toast.followerRemoved': 'Подписчик успешно удален',
    'merchantTools.toast.followerRemoveError': 'Не удалось удалить подписчика',
    'merchantTools.toast.filesUploaded': 'Файлы успешно загружены',
    'merchantTools.toast.filesUploadError': 'Не удалось загрузить файлы',
    'merchantTools.toast.fileDeleted': 'Файл успешно удален',
    'merchantTools.toast.fileDeleteError': 'Не удалось удалить файл',
    'merchantTools.toast.productCreated': 'Продукт успешно создан',
    'merchantTools.toast.productCreateError': 'Не удалось создать продукт',
    'merchantTools.toast.productUpdated': 'Продукт успешно обновлен',
    'merchantTools.toast.productUpdateError': 'Не удалось обновить продукт',
    'merchantTools.toast.productDeleted': 'Продукт успешно удален',
    'merchantTools.toast.productDeleteError': 'Не удалось удалить продукт',
    'vaiu.merchant.getting_paid': 'Получение Платежей',
    'vaiu.merchant.getting_paid_description': 'Создавайте ссылки на оплату и QR-коды для получения платежей от клиентов',
    'vaiu.merchant.payment_link': 'Ссылка на Оплату',
    'vaiu.merchant.embedded_payment': 'Встроенный Платеж',
    'vaiu.merchant.preview': 'Предпросмотр',
    'vaiu.merchant.download_qr': 'Скачать QR',
    'vaiu.merchant.copy_link': 'Копировать Ссылку',
    'vaiu.merchant.copy_iframe': 'Копировать Iframe',
  },
  pt: {
    'merchantTools.title': 'Ferramentas do Comerciante',
    'merchantTools.subtitle': 'Gerencie suas operações comerciais e ferramentas de venda',
    'merchantTools.viewPublicProfile': 'Ver Perfil Público',
    'merchantTools.view': 'Ver',
    'merchantTools.fastTrack': 'Configuração Rápida',
    'merchantTools.setup': 'Configurar',
    'merchantTools.settings': 'Configurações do Comerciante',
    'merchantTools.completePayoutSetup': 'Complete Sua Configuração de Pagamento',
    'merchantTools.payoutSetupDesc': 'Para receber pagamentos de suas vendas, você precisa configurar um dos seguintes:',
    'merchantTools.linkBankAccount': 'Vincular Conta Bancária',
    'merchantTools.stripeConnect': 'Stripe Connect',
    'merchantTools.paypalAccount': 'Conta PayPal',
    'merchantTools.completeProfile': 'Complete seu perfil de comerciante para desbloquear todos os recursos e começar a aceitar pagamentos.',
    'merchantTools.setupNow': 'Configurar Agora →',
    'merchantTools.dashboard': 'Painel',
    'merchantTools.newTokens': 'Novos Tokens!',
    'merchantTools.quickActions': 'Ações Rápidas (Demo do Modelo OOP)',
    'merchantTools.actionsAvailable': '{count} disponíveis',
    'merchantTools.actionTriggered': 'Ação Acionada',
    'merchantTools.wouldOpen': 'Abriria: {action}',
    'merchantTools.permissions': 'Suas Permissões de Comerciante',
    'merchantTools.permissions.createProducts': 'Criar Produtos',
    'merchantTools.permissions.apiKeys': 'Chaves de API',
    'merchantTools.permissions.analytics': 'Analíticas',
    'merchantTools.permissions.invoicing': 'Faturamento',
    'merchantTools.permissions.qrCodes': 'Códigos QR',
    'merchantTools.permissions.exportData': 'Exportar Dados',
    'merchantTools.announce': 'Anunciar para Seguidores',
    'merchantTools.followers': '{count} seguidores',
    'merchantTools.createAnnouncement': 'Criar Anúncio',
    'merchantTools.announcementTitle': 'Título',
    'merchantTools.announcementTitlePlaceholder': 'Insira o título do anúncio...',
    'merchantTools.announcementMessage': 'Mensagem',
    'merchantTools.announcementMessagePlaceholder': 'Escreva sua mensagem de anúncio...',
    'merchantTools.sendToAll': 'Enviar para todos os seguidores',
    'merchantTools.selectFollowers': 'Selecionar Seguidores',
    'merchantTools.sending': 'Enviando...',
    'merchantTools.sendAnnouncement': 'Enviar Anúncio',
    'merchantTools.noFollowers': 'Você ainda não tem seguidores. Seguidores são usuários cujos tokens de dinheiro você resgatou.',
    'merchantTools.yourFollowers': 'Seus Seguidores',
    'merchantTools.active': 'Ativo',
    'merchantTools.tokensRedeemed': '{count} tokens resgatados',
    'merchantTools.followingSince': 'Seguindo desde {date}',
    'merchantTools.noFollowersYet': 'Ainda não há seguidores',
    'merchantTools.noFollowersHint': 'Usuários se tornam seguidores quando você resgata seus tokens de dinheiro',
    'merchantTools.previousAnnouncements': 'Anúncios Anteriores',
    'merchantTools.recipients': '{count} destinatários',
    'merchantTools.read': '{count} lidos',
    'merchantTools.sellingTools': 'Ferramentas de Venda',
    'merchantTools.productCatalog': 'Catálogo de Produtos',
    'merchantTools.manageProducts': 'Gerencie seus produtos e inventário',
    'merchantTools.uploadMenu': 'Enviar Menu (IA)',
    'merchantTools.importFeed': 'Importar Feed',
    'merchantTools.addProduct': 'Adicionar Produto',
    'merchantTools.integrations': 'Integrações de Plataforma E-commerce',
    'merchantTools.integrationsDesc': 'Conecte pagamentos Vaiu à sua loja online com nossos plugins e extensões',
    'merchantTools.wooCommerce': 'WooCommerce',
    'merchantTools.wooCommerceDesc': 'Aceite pagamentos Vaiu diretamente em sua loja WooCommerce',
    'merchantTools.wooCommercePlugin': 'Plugin WordPress',
    'merchantTools.download': 'Baixar',
    'merchantTools.docs': 'Documentação',
    'merchantTools.shopify': 'Shopify',
    'merchantTools.shopifyDesc': 'Instale o aplicativo de pagamento Vaiu da Shopify App Store',
    'merchantTools.shopifyApp': 'Aplicativo Shopify',
    'merchantTools.install': 'Instalar',
    'merchantTools.guide': 'Guia',
    'merchantTools.magento': 'Magento',
    'merchantTools.magentoDesc': 'Integre pagamentos Vaiu com sua loja Magento',
    'merchantTools.magentoExtension': 'Extensão',
    'merchantTools.businessFiles': 'Arquivos do Negócio',
    'merchantTools.businessFilesDesc': 'Envie e gerencie seus documentos comerciais, logos e mídia',
    'merchantTools.uploading': 'Enviando...',
    'merchantTools.uploadFiles': 'Enviar Arquivos',
    'merchantTools.noFiles': 'Nenhum arquivo enviado ainda',
    'merchantTools.noFilesDesc': 'Envie documentos comerciais, logos e arquivos de mídia',
    'merchantTools.unlockPotential': 'Pronto para desbloquear todo o potencial do seu negócio?',
    'merchantTools.unlockPotentialDesc': 'Complete a configuração do seu perfil para acessar todos os recursos, aceitar pagamentos e expandir seu negócio.',
    'merchantTools.completeSetup': 'Completar Configuração',
    'merchantTools.toast.menuUploaded': 'Menu Enviado com Sucesso',
    'merchantTools.toast.menuUploadedDesc': 'Adicionados {count} itens ao seu catálogo de produtos.',
    'merchantTools.toast.profileError': 'Falha ao carregar perfil do comerciante',
    'merchantTools.toast.filesError': 'Falha ao carregar arquivos',
    'merchantTools.toast.productsError': 'Falha ao carregar produtos',
    'merchantTools.toast.followersError': 'Falha ao carregar seguidores',
    'merchantTools.toast.announcementError': 'Por favor, preencha título e mensagem',
    'merchantTools.toast.announcementFollowersError': 'Por favor, selecione pelo menos um seguidor ou envie para todos',
    'merchantTools.toast.announcementSuccess': 'Anúncio enviado para {count} seguidores',
    'merchantTools.toast.announcementFailed': 'Falha ao enviar anúncio',
    'merchantTools.toast.followerRemoved': 'Seguidor removido com sucesso',
    'merchantTools.toast.followerRemoveError': 'Falha ao remover seguidor',
    'merchantTools.toast.filesUploaded': 'Arquivos enviados com sucesso',
    'merchantTools.toast.filesUploadError': 'Falha ao enviar arquivos',
    'merchantTools.toast.fileDeleted': 'Arquivo excluído com sucesso',
    'merchantTools.toast.fileDeleteError': 'Falha ao excluir arquivo',
    'merchantTools.toast.productCreated': 'Produto criado com sucesso',
    'merchantTools.toast.productCreateError': 'Falha ao criar produto',
    'merchantTools.toast.productUpdated': 'Produto atualizado com sucesso',
    'merchantTools.toast.productUpdateError': 'Falha ao atualizar produto',
    'merchantTools.toast.productDeleted': 'Produto excluído com sucesso',
    'merchantTools.toast.productDeleteError': 'Falha ao excluir produto',
    'vaiu.merchant.getting_paid': 'Receber Pagamentos',
    'vaiu.merchant.getting_paid_description': 'Crie links de pagamento e códigos QR para receber pagamentos de clientes',
    'vaiu.merchant.payment_link': 'Link de Pagamento',
    'vaiu.merchant.embedded_payment': 'Pagamento Incorporado',
    'vaiu.merchant.preview': 'Visualizar',
    'vaiu.merchant.download_qr': 'Baixar QR',
    'vaiu.merchant.copy_link': 'Copiar Link',
    'vaiu.merchant.copy_iframe': 'Copiar Iframe',
  },
  el: {
    'merchantTools.title': 'Εργαλεία Εμπόρου',
    'merchantTools.subtitle': 'Διαχειριστείτε τις επιχειρηματικές σας λειτουργίες και τα εργαλεία πώλησης',
    'merchantTools.viewPublicProfile': 'Προβολή Δημόσιου Προφίλ',
    'merchantTools.view': 'Προβολή',
    'merchantTools.fastTrack': 'Γρήγορη Ρύθμιση',
    'merchantTools.setup': 'Ρύθμιση',
    'merchantTools.settings': 'Ρυθμίσεις Εμπόρου',
    'merchantTools.completePayoutSetup': 'Ολοκληρώστε τη Ρύθμιση Εκπληρωμών',
    'merchantTools.payoutSetupDesc': 'Για να λάβετε πληρωμές από τις πωλήσεις σας, πρέπει να ρυθμίσετε ένα από τα ακόλουθα:',
    'merchantTools.linkBankAccount': 'Σύνδεση Τραπεζικού Λογαριασμού',
    'merchantTools.stripeConnect': 'Stripe Connect',
    'merchantTools.paypalAccount': 'Λογαριασμός PayPal',
    'merchantTools.completeProfile': 'Ολοκληρώστε το προφίλ εμπόρου σας για να ξεκλειδώσετε όλες τις λειτουργίες και να αρχίσετε να δέχεστε πληρωμές.',
    'merchantTools.setupNow': 'Ρύθμιση Τώρα →',
    'merchantTools.dashboard': 'Πίνακας Ελέγχου',
    'merchantTools.newTokens': 'Νέα Tokens!',
    'merchantTools.quickActions': 'Γρήγορες Ενέργειες (Επίδειξη Μοντέλου OOP)',
    'merchantTools.actionsAvailable': '{count} διαθέσιμες',
    'merchantTools.actionTriggered': 'Ενέργεια Ενεργοποιήθηκε',
    'merchantTools.wouldOpen': 'Θα άνοιγε: {action}',
    'merchantTools.permissions': 'Οι Άδειες Εμπόρου Σας',
    'merchantTools.permissions.createProducts': 'Δημιουργία Προϊόντων',
    'merchantTools.permissions.apiKeys': 'Κλειδιά API',
    'merchantTools.permissions.analytics': 'Αναλυτικά',
    'merchantTools.permissions.invoicing': 'Τιμολόγηση',
    'merchantTools.permissions.qrCodes': 'Κωδικοί QR',
    'merchantTools.permissions.exportData': 'Εξαγωγή Δεδομένων',
    'merchantTools.announce': 'Ανακοίνωση στους Ακόλουθους',
    'merchantTools.followers': '{count} ακόλουθοι',
    'merchantTools.createAnnouncement': 'Δημιουργία Ανακοίνωσης',
    'merchantTools.announcementTitle': 'Τίτλος',
    'merchantTools.announcementTitlePlaceholder': 'Εισάγετε τίτλο ανακοίνωσης...',
    'merchantTools.announcementMessage': 'Μήνυμα',
    'merchantTools.announcementMessagePlaceholder': 'Γράψτε το μήνυμα ανακοίνωσής σας...',
    'merchantTools.sendToAll': 'Αποστολή σε όλους τους ακόλουθους',
    'merchantTools.selectFollowers': 'Επιλογή Ακόλουθων',
    'merchantTools.sending': 'Αποστολή...',
    'merchantTools.sendAnnouncement': 'Αποστολή Ανακοίνωσης',
    'merchantTools.noFollowers': 'Δεν έχετε ακόμα ακόλουθους. Οι ακόλουθοι είναι χρήστες των οποίων τα tokens μετρητών έχετε εξαργυρώσει.',
    'merchantTools.yourFollowers': 'Οι Ακόλουθοί Σας',
    'merchantTools.active': 'Ενεργό',
    'merchantTools.tokensRedeemed': '{count} tokens εξαργυρωμένα',
    'merchantTools.followingSince': 'Ακολουθεί από {date}',
    'merchantTools.noFollowersYet': 'Δεν υπάρχουν ακόμα ακόλουθοι',
    'merchantTools.noFollowersHint': 'Οι χρήστες γίνονται ακόλουθοι όταν εξαργυρώνετε τα tokens μετρητών τους',
    'merchantTools.previousAnnouncements': 'Προηγούμενες Ανακοινώσεις',
    'merchantTools.recipients': '{count} παραλήπτες',
    'merchantTools.read': '{count} διαβασμένα',
    'merchantTools.sellingTools': 'Εργαλεία Πώλησης',
    'merchantTools.productCatalog': 'Κατάλογος Προϊόντων',
    'merchantTools.manageProducts': 'Διαχειριστείτε τα προϊόντα και το απόθεμά σας',
    'merchantTools.uploadMenu': 'Ανέβασμα Μενού (AI)',
    'merchantTools.importFeed': 'Εισαγωγή Feed',
    'merchantTools.addProduct': 'Προσθήκη Προϊόντος',
    'merchantTools.integrations': 'Ενσωματώσεις Πλατφορμών E-commerce',
    'merchantTools.integrationsDesc': 'Συνδέστε τις πληρωμές Vaiu στο διαδικτυακό σας κατάστημα με τα plugins και τις επεκτάσεις μας',
    'merchantTools.wooCommerce': 'WooCommerce',
    'merchantTools.wooCommerceDesc': 'Δέχεστε πληρωμές Vaiu απευθείας στο κατάστημα WooCommerce σας',
    'merchantTools.wooCommercePlugin': 'Plugin WordPress',
    'merchantTools.download': 'Λήψη',
    'merchantTools.docs': 'Έγγραφα',
    'merchantTools.shopify': 'Shopify',
    'merchantTools.shopifyDesc': 'Εγκαταστήστε την εφαρμογή πληρωμών Vaiu από το Shopify App Store',
    'merchantTools.shopifyApp': 'Εφαρμογή Shopify',
    'merchantTools.install': 'Εγκατάσταση',
    'merchantTools.guide': 'Οδηγός',
    'merchantTools.magento': 'Magento',
    'merchantTools.magentoDesc': 'Ενσωματώστε τις πληρωμές Vaiu με το κατάστημα Magento σας',
    'merchantTools.magentoExtension': 'Επέκταση',
    'merchantTools.businessFiles': 'Επιχειρηματικά Αρχεία',
    'merchantTools.businessFilesDesc': 'Ανεβάστε και διαχειριστείτε τα επιχειρηματικά σας έγγραφα, λογότυπα και μέσα',
    'merchantTools.uploading': 'Ανέβασμα...',
    'merchantTools.uploadFiles': 'Ανέβασμα Αρχείων',
    'merchantTools.noFiles': 'Δεν έχουν ανέβει ακόμα αρχεία',
    'merchantTools.noFilesDesc': 'Ανεβάστε επιχειρηματικά έγγραφα, λογότυπα και αρχεία πολυμέσων',
    'merchantTools.unlockPotential': 'Έτοιμοι να ξεκλειδώσετε το πλήρες δυναμικό εμπόρου;',
    'merchantTools.unlockPotentialDesc': 'Ολοκληρώστε τη ρύθμιση προφίλ για να αποκτήσετε πρόσβαση σε όλες τις λειτουργίες, να δέχεστε πληρωμές και να αναπτύξετε την επιχείρησή σας.',
    'merchantTools.completeSetup': 'Ολοκλήρωση Ρύθμισης',
    'merchantTools.toast.menuUploaded': 'Το Μενού Ανέβηκε με Επιτυχία',
    'merchantTools.toast.menuUploadedDesc': 'Προστέθηκαν {count} στοιχεία στον κατάλογο προϊόντων σας.',
    'merchantTools.toast.profileError': 'Αποτυχία φόρτωσης προφίλ εμπόρου',
    'merchantTools.toast.filesError': 'Αποτυχία φόρτωσης αρχείων',
    'merchantTools.toast.productsError': 'Αποτυχία φόρτωσης προϊόντων',
    'merchantTools.toast.followersError': 'Αποτυχία φόρτωσης ακόλουθων',
    'merchantTools.toast.announcementError': 'Παρακαλώ συμπληρώστε τόσο τον τίτλο όσο και το μήνυμα',
    'merchantTools.toast.announcementFollowersError': 'Παρακαλώ επιλέξτε τουλάχιστον έναν ακόλουθο ή στείλτε σε όλους',
    'merchantTools.toast.announcementSuccess': 'Η ανακοίνωση στάλθηκε σε {count} ακόλουθους',
    'merchantTools.toast.announcementFailed': 'Αποτυχία αποστολής ανακοίνωσης',
    'merchantTools.toast.followerRemoved': 'Ο ακόλουθος αφαιρέθηκε με επιτυχία',
    'merchantTools.toast.followerRemoveError': 'Αποτυχία αφαίρεσης ακόλουθου',
    'merchantTools.toast.filesUploaded': 'Τα αρχεία ανέβηκαν με επιτυχία',
    'merchantTools.toast.filesUploadError': 'Αποτυχία ανεβάσματος αρχείων',
    'merchantTools.toast.fileDeleted': 'Το αρχείο διαγράφηκε με επιτυχία',
    'merchantTools.toast.fileDeleteError': 'Αποτυχία διαγραφής αρχείου',
    'merchantTools.toast.productCreated': 'Το προϊόν δημιουργήθηκε με επιτυχία',
    'merchantTools.toast.productCreateError': 'Αποτυχία δημιουργίας προϊόντος',
    'merchantTools.toast.productUpdated': 'Το προϊόν ενημερώθηκε με επιτυχία',
    'merchantTools.toast.productUpdateError': 'Αποτυχία ενημέρωσης προϊόντος',
    'merchantTools.toast.productDeleted': 'Το προϊόν διαγράφηκε με επιτυχία',
    'merchantTools.toast.productDeleteError': 'Αποτυχία διαγραφής προϊόντος',
    'vaiu.merchant.getting_paid': 'Λήψη Πληρωμών',
    'vaiu.merchant.getting_paid_description': 'Δημιουργήστε συνδέσμους πληρωμής και κωδικούς QR για να λαμβάνετε πληρωμές από πελάτες',
    'vaiu.merchant.payment_link': 'Σύνδεσμος Πληρωμής',
    'vaiu.merchant.embedded_payment': 'Ενσωματωμένη Πληρωμή',
    'vaiu.merchant.preview': 'Προεπισκόπηση',
    'vaiu.merchant.download_qr': 'Λήψη QR',
    'vaiu.merchant.copy_link': 'Αντιγραφή Συνδέσμου',
    'vaiu.merchant.copy_iframe': 'Αντιγραφή Iframe',
  },
  de: {
    'merchantTools.title': 'Händler-Tools',
    'merchantTools.subtitle': 'Verwalten Sie Ihre Geschäftsabläufe und Verkaufstools',
    'merchantTools.viewPublicProfile': 'Öffentliches Profil anzeigen',
    'merchantTools.view': 'Anzeigen',
    'merchantTools.fastTrack': 'Schnellstart-Einrichtung',
    'merchantTools.setup': 'Einrichtung',
    'merchantTools.settings': 'Händler-Einstellungen',
    'merchantTools.completePayoutSetup': 'Vervollständigen Sie Ihre Auszahlungs-Einrichtung',
    'merchantTools.payoutSetupDesc': 'Um Zahlungen von Ihren Verkäufen zu erhalten, müssen Sie eines der folgenden einrichten:',
    'merchantTools.linkBankAccount': 'Bankkonto verknüpfen',
    'merchantTools.stripeConnect': 'Stripe Connect',
    'merchantTools.paypalAccount': 'PayPal-Konto',
    'merchantTools.completeProfile': 'Vervollständigen Sie Ihr Händler-Profil, um alle Funktionen freizuschalten und Zahlungen zu akzeptieren.',
    'merchantTools.setupNow': 'Jetzt einrichten →',
    'merchantTools.dashboard': 'Dashboard',
    'merchantTools.newTokens': 'Neue Tokens!',
    'merchantTools.quickActions': 'Schnellaktionen (OOP-Modell-Demo)',
    'merchantTools.actionsAvailable': '{count} verfügbar',
    'merchantTools.actionTriggered': 'Aktion ausgelöst',
    'merchantTools.wouldOpen': 'Würde öffnen: {action}',
    'merchantTools.permissions': 'Ihre Händler-Berechtigungen',
    'merchantTools.permissions.createProducts': 'Produkte erstellen',
    'merchantTools.permissions.apiKeys': 'API-Schlüssel',
    'merchantTools.permissions.analytics': 'Analysen',
    'merchantTools.permissions.invoicing': 'Rechnungsstellung',
    'merchantTools.permissions.qrCodes': 'QR-Codes',
    'merchantTools.permissions.exportData': 'Daten exportieren',
    'merchantTools.announce': 'An Follower ankündigen',
    'merchantTools.followers': '{count} Follower',
    'merchantTools.createAnnouncement': 'Ankündigung erstellen',
    'merchantTools.announcementTitle': 'Titel',
    'merchantTools.announcementTitlePlaceholder': 'Ankündigungstitel eingeben...',
    'merchantTools.announcementMessage': 'Nachricht',
    'merchantTools.announcementMessagePlaceholder': 'Schreiben Sie Ihre Ankündigungsnachricht...',
    'merchantTools.sendToAll': 'An alle Follower senden',
    'merchantTools.selectFollowers': 'Follower auswählen',
    'merchantTools.sending': 'Wird gesendet...',
    'merchantTools.sendAnnouncement': 'Ankündigung senden',
    'merchantTools.noFollowers': 'Sie haben noch keine Follower. Follower sind Benutzer, deren Cash-Tokens Sie eingelöst haben.',
    'merchantTools.yourFollowers': 'Ihre Follower',
    'merchantTools.active': 'Aktiv',
    'merchantTools.tokensRedeemed': '{count} Tokens eingelöst',
    'merchantTools.followingSince': 'Folgt seit {date}',
    'merchantTools.noFollowersYet': 'Noch keine Follower',
    'merchantTools.noFollowersHint': 'Benutzer werden zu Followern, wenn Sie ihre Cash-Tokens einlösen',
    'merchantTools.previousAnnouncements': 'Vorherige Ankündigungen',
    'merchantTools.recipients': '{count} Empfänger',
    'merchantTools.read': '{count} gelesen',
    'merchantTools.sellingTools': 'Verkaufstools',
    'merchantTools.productCatalog': 'Produktkatalog',
    'merchantTools.manageProducts': 'Verwalten Sie Ihre Produkte und Ihr Inventar',
    'merchantTools.uploadMenu': 'Menü hochladen (KI)',
    'merchantTools.importFeed': 'Feed importieren',
    'merchantTools.addProduct': 'Produkt hinzufügen',
    'merchantTools.integrations': 'E-Commerce-Plattform-Integrationen',
    'merchantTools.integrationsDesc': 'Verbinden Sie Vaiu-Zahlungen mit Ihrem Online-Shop mit unseren Plugins und Erweiterungen',
    'merchantTools.wooCommerce': 'WooCommerce',
    'merchantTools.wooCommerceDesc': 'Akzeptieren Sie Vaiu-Zahlungen direkt in Ihrem WooCommerce-Shop',
    'merchantTools.wooCommercePlugin': 'WordPress-Plugin',
    'merchantTools.download': 'Herunterladen',
    'merchantTools.docs': 'Dokumentation',
    'merchantTools.shopify': 'Shopify',
    'merchantTools.shopifyDesc': 'Installieren Sie die Vaiu-Zahlungs-App aus dem Shopify App Store',
    'merchantTools.shopifyApp': 'Shopify-App',
    'merchantTools.install': 'Installieren',
    'merchantTools.guide': 'Anleitung',
    'merchantTools.magento': 'Magento',
    'merchantTools.magentoDesc': 'Integrieren Sie Vaiu-Zahlungen mit Ihrem Magento-Shop',
    'merchantTools.magentoExtension': 'Erweiterung',
    'merchantTools.businessFiles': 'Geschäftsdateien',
    'merchantTools.businessFilesDesc': 'Laden Sie Ihre Geschäftsdokumente, Logos und Medien hoch und verwalten Sie sie',
    'merchantTools.uploading': 'Wird hochgeladen...',
    'merchantTools.uploadFiles': 'Dateien hochladen',
    'merchantTools.noFiles': 'Noch keine Dateien hochgeladen',
    'merchantTools.noFilesDesc': 'Laden Sie Geschäftsdokumente, Logos und Mediendateien hoch',
    'merchantTools.unlockPotential': 'Bereit, Ihr volles Händler-Potenzial freizuschalten?',
    'merchantTools.unlockPotentialDesc': 'Vervollständigen Sie Ihre Profil-Einrichtung, um auf alle Funktionen zuzugreifen, Zahlungen zu akzeptieren und Ihr Geschäft zu erweitern.',
    'merchantTools.completeSetup': 'Einrichtung abschließen',
    'merchantTools.toast.menuUploaded': 'Menü erfolgreich hochgeladen',
    'merchantTools.toast.menuUploadedDesc': '{count} Artikel zu Ihrem Produktkatalog hinzugefügt.',
    'merchantTools.toast.profileError': 'Händler-Profil konnte nicht geladen werden',
    'merchantTools.toast.filesError': 'Dateien konnten nicht geladen werden',
    'merchantTools.toast.productsError': 'Produkte konnten nicht geladen werden',
    'merchantTools.toast.followersError': 'Follower konnten nicht geladen werden',
    'merchantTools.toast.announcementError': 'Bitte füllen Sie sowohl Titel als auch Nachricht aus',
    'merchantTools.toast.announcementFollowersError': 'Bitte wählen Sie mindestens einen Follower aus oder senden Sie an alle',
    'merchantTools.toast.announcementSuccess': 'Ankündigung an {count} Follower gesendet',
    'merchantTools.toast.announcementFailed': 'Ankündigung konnte nicht gesendet werden',
    'merchantTools.toast.followerRemoved': 'Follower erfolgreich entfernt',
    'merchantTools.toast.followerRemoveError': 'Follower konnte nicht entfernt werden',
    'merchantTools.toast.filesUploaded': 'Dateien erfolgreich hochgeladen',
    'merchantTools.toast.filesUploadError': 'Dateien konnten nicht hochgeladen werden',
    'merchantTools.toast.fileDeleted': 'Datei erfolgreich gelöscht',
    'merchantTools.toast.fileDeleteError': 'Datei konnte nicht gelöscht werden',
    'merchantTools.toast.productCreated': 'Produkt erfolgreich erstellt',
    'merchantTools.toast.productCreateError': 'Produkt konnte nicht erstellt werden',
    'merchantTools.toast.productUpdated': 'Produkt erfolgreich aktualisiert',
    'merchantTools.toast.productUpdateError': 'Produkt konnte nicht aktualisiert werden',
    'merchantTools.toast.productDeleted': 'Produkt erfolgreich gelöscht',
    'merchantTools.toast.productDeleteError': 'Produkt konnte nicht gelöscht werden',
    'vaiu.merchant.getting_paid': 'Zahlungen Erhalten',
    'vaiu.merchant.getting_paid_description': 'Erstellen Sie Zahlungslinks und QR-Codes, um Zahlungen von Kunden zu erhalten',
    'vaiu.merchant.payment_link': 'Zahlungslink',
    'vaiu.merchant.embedded_payment': 'Eingebettete Zahlung',
    'vaiu.merchant.preview': 'Vorschau',
    'vaiu.merchant.download_qr': 'QR Herunterladen',
    'vaiu.merchant.copy_link': 'Link Kopieren',
    'vaiu.merchant.copy_iframe': 'Iframe Kopieren',
  },
  ro: {
    'merchantTools.title': 'Instrumente Comerciant',
    'merchantTools.subtitle': 'Gestionați operațiunile afacerii și instrumentele de vânzare',
    'merchantTools.viewPublicProfile': 'Vezi Profil Public',
    'merchantTools.view': 'Vezi',
    'merchantTools.fastTrack': 'Configurare Rapidă',
    'merchantTools.setup': 'Configurare',
    'merchantTools.settings': 'Setări Comerciant',
    'merchantTools.completePayoutSetup': 'Finalizați Configurarea Plăților',
    'merchantTools.payoutSetupDesc': 'Pentru a primi plăți de la vânzările dvs., trebuie să configurați unul dintre următoarele:',
    'merchantTools.linkBankAccount': 'Vinculează Cont Bancar',
    'merchantTools.stripeConnect': 'Stripe Connect',
    'merchantTools.paypalAccount': 'Cont PayPal',
    'merchantTools.completeProfile': 'Finalizați profilul dvs. de comerciant pentru a debloca toate funcțiile și a începe să acceptați plăți.',
    'merchantTools.setupNow': 'Configurează Acum →',
    'merchantTools.dashboard': 'Panou',
    'merchantTools.newTokens': 'Tokenuri Noi!',
    'merchantTools.quickActions': 'Acțiuni Rapide (Demo Model OOP)',
    'merchantTools.actionsAvailable': '{count} disponibile',
    'merchantTools.actionTriggered': 'Acțiune Declanșată',
    'merchantTools.wouldOpen': 'Ar deschide: {action}',
    'merchantTools.permissions': 'Permisiunile Dvs. de Comerciant',
    'merchantTools.permissions.createProducts': 'Creați Produse',
    'merchantTools.permissions.apiKeys': 'Chei API',
    'merchantTools.permissions.analytics': 'Analize',
    'merchantTools.permissions.invoicing': 'Facturare',
    'merchantTools.permissions.qrCodes': 'Coduri QR',
    'merchantTools.permissions.exportData': 'Exportă Date',
    'merchantTools.announce': 'Anunță Seguitorilor',
    'merchantTools.followers': '{count} seguitori',
    'merchantTools.createAnnouncement': 'Creați Anunț',
    'merchantTools.announcementTitle': 'Titlu',
    'merchantTools.announcementTitlePlaceholder': 'Introduceți titlul anunțului...',
    'merchantTools.announcementMessage': 'Mesaj',
    'merchantTools.announcementMessagePlaceholder': 'Scrieți mesajul dvs. de anunț...',
    'merchantTools.sendToAll': 'Trimite tuturor seguitorilor',
    'merchantTools.selectFollowers': 'Selectează Seguitori',
    'merchantTools.sending': 'Se trimite...',
    'merchantTools.sendAnnouncement': 'Trimite Anunț',
    'merchantTools.noFollowers': 'Nu aveți încă seguitori. Seguitorii sunt utilizatori ai căror tokenuri de bani le-ați răscumpărat.',
    'merchantTools.yourFollowers': 'Seguitorii Dvs.',
    'merchantTools.active': 'Activ',
    'merchantTools.tokensRedeemed': '{count} tokenuri răscumpărate',
    'merchantTools.followingSince': 'Urmărește din {date}',
    'merchantTools.noFollowersYet': 'Niciun seguitor încă',
    'merchantTools.noFollowersHint': 'Utilizatorii devin seguitori când răscumpărați tokenurile lor de bani',
    'merchantTools.previousAnnouncements': 'Anunțuri Anterioare',
    'merchantTools.recipients': '{count} destinatari',
    'merchantTools.read': '{count} citite',
    'merchantTools.sellingTools': 'Instrumente de Vânzare',
    'merchantTools.productCatalog': 'Catalog Produse',
    'merchantTools.manageProducts': 'Gestionați produsele și inventarul dvs.',
    'merchantTools.uploadMenu': 'Încarcă Meniu (IA)',
    'merchantTools.importFeed': 'Importă Feed',
    'merchantTools.addProduct': 'Adaugă Produs',
    'merchantTools.integrations': 'Integrări Platformă E-commerce',
    'merchantTools.integrationsDesc': 'Conectați plățile Vaiu la magazinul dvs. online cu plugin-urile și extensiile noastre',
    'merchantTools.wooCommerce': 'WooCommerce',
    'merchantTools.wooCommerceDesc': 'Acceptați plăți Vaiu direct în magazinul dvs. WooCommerce',
    'merchantTools.wooCommercePlugin': 'Plugin WordPress',
    'merchantTools.download': 'Descarcă',
    'merchantTools.docs': 'Documentație',
    'merchantTools.shopify': 'Shopify',
    'merchantTools.shopifyDesc': 'Instalați aplicația de plată Vaiu din Shopify App Store',
    'merchantTools.shopifyApp': 'Aplicație Shopify',
    'merchantTools.install': 'Instalează',
    'merchantTools.guide': 'Ghid',
    'merchantTools.magento': 'Magento',
    'merchantTools.magentoDesc': 'Integrați plăți Vaiu cu magazinul dvs. Magento',
    'merchantTools.magentoExtension': 'Extensie',
    'merchantTools.businessFiles': 'Fișiere Afacere',
    'merchantTools.businessFilesDesc': 'Încărcați și gestionați documentele, logo-urile și media dvs. de afaceri',
    'merchantTools.uploading': 'Se încarcă...',
    'merchantTools.uploadFiles': 'Încarcă Fișiere',
    'merchantTools.noFiles': 'Niciun fișier încărcat încă',
    'merchantTools.noFilesDesc': 'Încărcați documente de afaceri, logo-uri și fișiere media',
    'merchantTools.unlockPotential': 'Gata să deblocați întregul potențial de comerciant?',
    'merchantTools.unlockPotentialDesc': 'Finalizați configurarea profilului pentru a accesa toate funcțiile, acceptați plăți și dezvoltați afacerea.',
    'merchantTools.completeSetup': 'Finalizează Configurarea',
    'merchantTools.toast.menuUploaded': 'Meniu Încărcat cu Succes',
    'merchantTools.toast.menuUploadedDesc': 'Adăugate {count} articole în catalogul dvs. de produse.',
    'merchantTools.toast.profileError': 'Nu s-a putut încărca profilul comerciantului',
    'merchantTools.toast.filesError': 'Nu s-au putut încărca fișierele',
    'merchantTools.toast.productsError': 'Nu s-au putut încărca produsele',
    'merchantTools.toast.followersError': 'Nu s-au putut încărca seguitorii',
    'merchantTools.toast.announcementError': 'Vă rugăm să completați atât titlul cât și mesajul',
    'merchantTools.toast.announcementFollowersError': 'Vă rugăm să selectați cel puțin un seguitor sau să trimiteți tuturor',
    'merchantTools.toast.announcementSuccess': 'Anunț trimis la {count} seguitori',
    'merchantTools.toast.announcementFailed': 'Nu s-a putut trimite anunțul',
    'merchantTools.toast.followerRemoved': 'Seguitor eliminat cu succes',
    'merchantTools.toast.followerRemoveError': 'Nu s-a putut elimina seguitorul',
    'merchantTools.toast.filesUploaded': 'Fișiere încărcate cu succes',
    'merchantTools.toast.filesUploadError': 'Nu s-au putut încărca fișierele',
    'merchantTools.toast.fileDeleted': 'Fișier șters cu succes',
    'merchantTools.toast.fileDeleteError': 'Nu s-a putut șterge fișierul',
    'merchantTools.toast.productCreated': 'Produs creat cu succes',
    'merchantTools.toast.productCreateError': 'Nu s-a putut crea produsul',
    'merchantTools.toast.productUpdated': 'Produs actualizat cu succes',
    'merchantTools.toast.productUpdateError': 'Nu s-a putut actualiza produsul',
    'merchantTools.toast.productDeleted': 'Produs șters cu succes',
    'merchantTools.toast.productDeleteError': 'Nu s-a putut șterge produsul',
    'vaiu.merchant.getting_paid': 'Primirea Plăților',
    'vaiu.merchant.getting_paid_description': 'Creați linkuri de plată și coduri QR pentru a primi plăți de la clienți',
    'vaiu.merchant.payment_link': 'Link de Plată',
    'vaiu.merchant.embedded_payment': 'Plată Integrată',
    'vaiu.merchant.preview': 'Previzualizare',
    'vaiu.merchant.download_qr': 'Descarcă QR',
    'vaiu.merchant.copy_link': 'Copiază Linkul',
    'vaiu.merchant.copy_iframe': 'Copiază Iframe',
  },
  sr: {
    'merchantTools.title': 'Алати за трговце',
    'merchantTools.subtitle': 'Управљајте пословним операцијама и алатима за продају',
    'merchantTools.viewPublicProfile': 'Погледај јавни профил',
    'merchantTools.view': 'Погледај',
    'merchantTools.fastTrack': 'Брза подешавања',
    'merchantTools.setup': 'Подешавања',
    'merchantTools.settings': 'Подешавања трговца',
    'merchantTools.completePayoutSetup': 'Завршите подешавање исплата',
    'merchantTools.payoutSetupDesc': 'Да бисте примали плаћања од ваших продаја, морате подесити једно од следећег:',
    'merchantTools.linkBankAccount': 'Повежи банковни рачун',
    'merchantTools.stripeConnect': 'Стрипе Цоннецт',
    'merchantTools.paypalAccount': 'ПаиПал налог',
    'merchantTools.completeProfile': 'Завршите ваш профил трговца да бисте откључали све функције и почели да прихватате плаћања.',
    'merchantTools.setupNow': 'Подеси сада →',
    'merchantTools.dashboard': 'Контролна табла',
    'merchantTools.newTokens': 'Нови токени!',
    'merchantTools.quickActions': 'Брзе акције (ООП модел демо)',
    'merchantTools.actionsAvailable': '{count} доступно',
    'merchantTools.actionTriggered': 'Акција покренута',
    'merchantTools.wouldOpen': 'Отворио би: {action}',
    'merchantTools.permissions': 'Ваше дозволе трговца',
    'merchantTools.permissions.createProducts': 'Креирај производе',
    'merchantTools.permissions.apiKeys': 'АПИ кључеви',
    'merchantTools.permissions.analytics': 'Аналитика',
    'merchantTools.permissions.invoicing': 'Фактурисање',
    'merchantTools.permissions.qrCodes': 'КР кодови',
    'merchantTools.permissions.exportData': 'Извези податке',
    'merchantTools.announce': 'Објави пратиоцима',
    'merchantTools.followers': '{count} пратилаца',
    'merchantTools.createAnnouncement': 'Креирај објаву',
    'merchantTools.announcementTitle': 'Наслов',
    'merchantTools.announcementTitlePlaceholder': 'Унесите наслов објаве...',
    'merchantTools.announcementMessage': 'Порука',
    'merchantTools.announcementMessagePlaceholder': 'Напишите вашу поруку објаве...',
    'merchantTools.sendToAll': 'Пошаљи свим пратиоцима',
    'merchantTools.selectFollowers': 'Изабери пратиоце',
    'merchantTools.sending': 'Слање...',
    'merchantTools.sendAnnouncement': 'Пошаљи објаву',
    'merchantTools.noFollowers': 'Још увек немате пратиоце. Пратиоци су корисници чије сте токене искористили.',
    'merchantTools.yourFollowers': 'Ваши пратиоци',
    'merchantTools.active': 'Активан',
    'merchantTools.tokensRedeemed': '{count} токена искоришћено',
    'merchantTools.followingSince': 'Прати од {date}',
    'merchantTools.noFollowersYet': 'Још нема пратилаца',
    'merchantTools.noFollowersHint': 'Корисници постају пратиоци када искористите њихове токене',
    'merchantTools.previousAnnouncements': 'Претходне објаве',
    'merchantTools.recipients': '{count} прималаца',
    'merchantTools.read': '{count} прочитано',
    'merchantTools.sellingTools': 'Алати за продају',
    'merchantTools.productCatalog': 'Каталог производа',
    'merchantTools.manageProducts': 'Управљајте вашим производима и залихама',
    'merchantTools.uploadMenu': 'Отпреми мени (АИ)',
    'merchantTools.importFeed': 'Увези фид',
    'merchantTools.addProduct': 'Додај производ',
    'merchantTools.integrations': 'Интеграције е-трговинских платформи',
    'merchantTools.integrationsDesc': 'Повежите Ваиу плаћања са вашем онлајн продавницом помоћу наших додатака и екстензија',
    'merchantTools.wooCommerce': 'WooCommerce',
    'merchantTools.wooCommerceDesc': 'Прихватите Ваиу плаћања директно у вашој WooCommerce продавници',
    'merchantTools.wooCommercePlugin': 'WordPress додатак',
    'merchantTools.download': 'Преузми',
    'merchantTools.docs': 'Документација',
    'merchantTools.shopify': 'Shopify',
    'merchantTools.shopifyDesc': 'Инсталирајте Ваиу апликацију за плаћање из Shopify App Store-а',
    'merchantTools.shopifyApp': 'Shopify апликација',
    'merchantTools.install': 'Инсталирај',
    'merchantTools.guide': 'Водич',
    'merchantTools.magento': 'Magento',
    'merchantTools.magentoDesc': 'Интегришите Ваиу плаћања са вашем Magento продавницом',
    'merchantTools.magentoExtension': 'Екстензија',
    'merchantTools.businessFiles': 'Пословни фајлови',
    'merchantTools.businessFilesDesc': 'Отпремите и управљајте вашим пословним документима, логотипима и медијама',
    'merchantTools.uploading': 'Отпремање...',
    'merchantTools.uploadFiles': 'Отпреми фајлове',
    'merchantTools.noFiles': 'Још увек нема отпремљених фајлова',
    'merchantTools.noFilesDesc': 'Отпремите пословне документе, логотипе и медијске фајлове',
    'merchantTools.unlockPotential': 'Спремни да откључате ваш пуни потенцијал трговца?',
    'merchantTools.unlockPotentialDesc': 'Завршите подешавање вашег профила да бисте приступили свим функцијама, прихватили плаћања и развили ваш посао.',
    'merchantTools.completeSetup': 'Заврши подешавање',
    'merchantTools.toast.menuUploaded': 'Мени успешно отпремљен',
    'merchantTools.toast.menuUploadedDesc': 'Додато {count} ставки у ваш каталог производа.',
    'merchantTools.toast.profileError': 'Није успело учитавање профила трговца',
    'merchantTools.toast.filesError': 'Није успело учитавање фајлова',
    'merchantTools.toast.productsError': 'Није успело учитавање производа',
    'merchantTools.toast.followersError': 'Није успело учитавање пратилаца',
    'merchantTools.toast.announcementError': 'Молимо попуните и наслов и поруку',
    'merchantTools.toast.announcementFollowersError': 'Молимо изаберите бар једног пратиоца или пошаљите свима',
    'merchantTools.toast.announcementSuccess': 'Објава послата {count} пратиоцима',
    'merchantTools.toast.announcementFailed': 'Слање објаве није успело',
    'merchantTools.toast.followerRemoved': 'Пратилац успешно уклоњен',
    'merchantTools.toast.followerRemoveError': 'Уклањање пратиоца није успело',
    'merchantTools.toast.filesUploaded': 'Фајлови успешно отпремљени',
    'merchantTools.toast.filesUploadError': 'Отпремање фајлова није успело',
    'merchantTools.toast.fileDeleted': 'Фајл успешно обрисан',
    'merchantTools.toast.fileDeleteError': 'Брисање фајла није успело',
    'merchantTools.toast.productCreated': 'Производ успешно креиран',
    'merchantTools.toast.productCreateError': 'Креирање производа није успело',
    'merchantTools.toast.productUpdated': 'Производ успешно ажуриран',
    'merchantTools.toast.productUpdateError': 'Ажурирање производа није успело',
    'merchantTools.toast.productDeleted': 'Производ успешно обрисан',
    'merchantTools.toast.productDeleteError': 'Брисање производа није успело',
    'vaiu.merchant.getting_paid': 'Примање Плаћања',
    'vaiu.merchant.getting_paid_description': 'Креирајте везе за плаћање и QR кодове за примање плаћања од клијената',
    'vaiu.merchant.payment_link': 'Веза за Плаћање',
    'vaiu.merchant.embedded_payment': 'Уграђено Плаћање',
    'vaiu.merchant.preview': 'Преглед',
    'vaiu.merchant.download_qr': 'Преузми QR',
    'vaiu.merchant.copy_link': 'Копирај Везу',
    'vaiu.merchant.copy_iframe': 'Копирај Iframe',
  },
  pl: {
    'merchantTools.title': 'Narzędzia sprzedawcy',
    'merchantTools.subtitle': 'Zarządzaj operacjami biznesowymi i narzędziami sprzedaży',
    'merchantTools.viewPublicProfile': 'Zobacz profil publiczny',
    'merchantTools.view': 'Zobacz',
    'merchantTools.fastTrack': 'Szybka konfiguracja',
    'merchantTools.setup': 'Konfiguracja',
    'merchantTools.settings': 'Ustawienia sprzedawcy',
    'merchantTools.completePayoutSetup': 'Ukończ konfigurację wypłat',
    'merchantTools.payoutSetupDesc': 'Aby otrzymywać płatności ze swoich sprzedaży, musisz skonfigurować jedno z następujących:',
    'merchantTools.linkBankAccount': 'Połącz konto bankowe',
    'merchantTools.stripeConnect': 'Stripe Connect',
    'merchantTools.paypalAccount': 'Konto PayPal',
    'merchantTools.completeProfile': 'Ukończ swój profil sprzedawcy, aby odblokować wszystkie funkcje i zacząć przyjmować płatności.',
    'merchantTools.setupNow': 'Skonfiguruj teraz →',
    'merchantTools.dashboard': 'Panel',
    'merchantTools.newTokens': 'Nowe tokeny!',
    'merchantTools.quickActions': 'Szybkie akcje (Demo modelu OOP)',
    'merchantTools.actionsAvailable': '{count} dostępne',
    'merchantTools.actionTriggered': 'Akcja wyzwolona',
    'merchantTools.wouldOpen': 'Otworzyłoby: {action}',
    'merchantTools.permissions': 'Twoje uprawnienia sprzedawcy',
    'merchantTools.permissions.createProducts': 'Tworzenie produktów',
    'merchantTools.permissions.apiKeys': 'Klucze API',
    'merchantTools.permissions.analytics': 'Analityka',
    'merchantTools.permissions.invoicing': 'Fakturowanie',
    'merchantTools.permissions.qrCodes': 'Kody QR',
    'merchantTools.permissions.exportData': 'Eksport danych',
    'merchantTools.announce': 'Ogłoś obserwującym',
    'merchantTools.followers': '{count} obserwujących',
    'merchantTools.createAnnouncement': 'Utwórz ogłoszenie',
    'merchantTools.announcementTitle': 'Tytuł',
    'merchantTools.announcementTitlePlaceholder': 'Wprowadź tytuł ogłoszenia...',
    'merchantTools.announcementMessage': 'Wiadomość',
    'merchantTools.announcementMessagePlaceholder': 'Napisz swoją wiadomość ogłoszenia...',
    'merchantTools.sendToAll': 'Wyślij do wszystkich obserwujących',
    'merchantTools.selectFollowers': 'Wybierz obserwujących',
    'merchantTools.sending': 'Wysyłanie...',
    'merchantTools.sendAnnouncement': 'Wyślij ogłoszenie',
    'merchantTools.noFollowers': 'Nie masz jeszcze żadnych obserwujących. Obserwujący to użytkownicy, których tokeny gotówkowe zrealizowałeś.',
    'merchantTools.yourFollowers': 'Twoi obserwujący',
    'merchantTools.active': 'Aktywny',
    'merchantTools.tokensRedeemed': '{count} tokenów zrealizowanych',
    'merchantTools.followingSince': 'Obserwuje od {date}',
    'merchantTools.noFollowersYet': 'Brak obserwujących',
    'merchantTools.noFollowersHint': 'Użytkownicy stają się obserwującymi, gdy realizujesz ich tokeny gotówkowe',
    'merchantTools.previousAnnouncements': 'Poprzednie ogłoszenia',
    'merchantTools.recipients': '{count} odbiorców',
    'merchantTools.read': '{count} przeczytanych',
    'merchantTools.sellingTools': 'Narzędzia sprzedaży',
    'merchantTools.productCatalog': 'Katalog produktów',
    'merchantTools.manageProducts': 'Zarządzaj swoimi produktami i zapasami',
    'merchantTools.uploadMenu': 'Prześlij menu (AI)',
    'merchantTools.importFeed': 'Importuj kanał',
    'merchantTools.addProduct': 'Dodaj produkt',
    'merchantTools.integrations': 'Integracje platform e-commerce',
    'merchantTools.integrationsDesc': 'Połącz płatności Vaiu ze swoim sklepem online za pomocą naszych wtyczek i rozszerzeń',
    'merchantTools.wooCommerce': 'WooCommerce',
    'merchantTools.wooCommerceDesc': 'Akceptuj płatności Vaiu bezpośrednio w swoim sklepie WooCommerce',
    'merchantTools.wooCommercePlugin': 'Wtyczka WordPress',
    'merchantTools.download': 'Pobierz',
    'merchantTools.docs': 'Dokumentacja',
    'merchantTools.shopify': 'Shopify',
    'merchantTools.shopifyDesc': 'Zainstaluj aplikację płatności Vaiu ze sklepu aplikacji Shopify',
    'merchantTools.shopifyApp': 'Aplikacja Shopify',
    'merchantTools.install': 'Zainstaluj',
    'merchantTools.guide': 'Przewodnik',
    'merchantTools.magento': 'Magento',
    'merchantTools.magentoDesc': 'Zintegruj płatności Vaiu ze swoim sklepem Magento',
    'merchantTools.magentoExtension': 'Rozszerzenie',
    'merchantTools.businessFiles': 'Pliki biznesowe',
    'merchantTools.businessFilesDesc': 'Prześlij i zarządzaj dokumentami biznesowymi, logo i mediami',
    'merchantTools.uploading': 'Przesyłanie...',
    'merchantTools.uploadFiles': 'Prześlij pliki',
    'merchantTools.noFiles': 'Nie przesłano jeszcze żadnych plików',
    'merchantTools.noFilesDesc': 'Prześlij dokumenty biznesowe, logo i pliki multimedialne',
    'merchantTools.unlockPotential': 'Gotowy, aby odblokować pełny potencjał sprzedawcy?',
    'merchantTools.unlockPotentialDesc': 'Ukończ konfigurację profilu, aby uzyskać dostęp do wszystkich funkcji, przyjmować płatności i rozwijać swój biznes.',
    'merchantTools.completeSetup': 'Ukończ konfigurację',
    'merchantTools.toast.menuUploaded': 'Menu przesłane pomyślnie',
    'merchantTools.toast.menuUploadedDesc': 'Dodano {count} pozycji do Twojego katalogu produktów.',
    'merchantTools.toast.profileError': 'Nie udało się załadować profilu sprzedawcy',
    'merchantTools.toast.filesError': 'Nie udało się załadować plików',
    'merchantTools.toast.productsError': 'Nie udało się załadować produktów',
    'merchantTools.toast.followersError': 'Nie udało się załadować obserwujących',
    'merchantTools.toast.announcementError': 'Proszę wypełnić zarówno tytuł, jak i wiadomość',
    'merchantTools.toast.announcementFollowersError': 'Proszę wybrać co najmniej jednego obserwującego lub wysłać do wszystkich',
    'merchantTools.toast.announcementSuccess': 'Ogłoszenie wysłane do {count} obserwujących',
    'merchantTools.toast.announcementFailed': 'Nie udało się wysłać ogłoszenia',
    'merchantTools.toast.followerRemoved': 'Obserwujący usunięty pomyślnie',
    'merchantTools.toast.followerRemoveError': 'Nie udało się usunąć obserwującego',
    'merchantTools.toast.filesUploaded': 'Pliki przesłane pomyślnie',
    'merchantTools.toast.filesUploadError': 'Nie udało się przesłać plików',
    'merchantTools.toast.fileDeleted': 'Plik usunięty pomyślnie',
    'merchantTools.toast.fileDeleteError': 'Nie udało się usunąć pliku',
    'merchantTools.toast.productCreated': 'Produkt utworzony pomyślnie',
    'merchantTools.toast.productCreateError': 'Nie udało się utworzyć produktu',
    'merchantTools.toast.productUpdated': 'Produkt zaktualizowany pomyślnie',
    'merchantTools.toast.productUpdateError': 'Nie udało się zaktualizować produktu',
    'merchantTools.toast.productDeleted': 'Produkt usunięty pomyślnie',
    'merchantTools.toast.productDeleteError': 'Nie udało się usunąć produktu',
    'vaiu.merchant.getting_paid': 'Otrzymywanie Płatności',
    'vaiu.merchant.getting_paid_description': 'Twórz linki płatności i kody QR, aby otrzymywać płatności od klientów',
    'vaiu.merchant.payment_link': 'Link Płatności',
    'vaiu.merchant.embedded_payment': 'Wbudowana Płatność',
    'vaiu.merchant.preview': 'Podgląd',
    'vaiu.merchant.download_qr': 'Pobierz QR',
    'vaiu.merchant.copy_link': 'Kopiuj Link',
    'vaiu.merchant.copy_iframe': 'Kopiuj Iframe',
  },
};
